import React from 'react'
import OnboardingSectionTitle from '../../../_global/OnboardingSectionTitle'
import Grid from '@material-ui/core/Grid'
import PitchForm from './Form'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useQuery } from '@apollo/react-hooks'
import PITCH_QUERY from '../../../apolloClient/queries/getPitch'
import Error from '../../../_global/Error'
import Loader from '../../../_global/Loader'
import { default as useGetTagsQuery } from '../../../apolloClient/queries/getTags'

const Pitch = () => {
  const { currentExpert } = useOnboarding()

  const { loading, error, data } = useQuery(PITCH_QUERY, {
    variables: { id: currentExpert.id },
    skip: !currentExpert.id,
  })

  const { loading: tagsLoading, error: tagsError, data: tagsData } = useGetTagsQuery()

  if (loading || tagsLoading) return <Loader />
  if (error || tagsError) return <Error />

  const {
    getExpert: { personalSummary },
  } = data

  const { industries, software, skills } = tagsData.getTags

  const initialValues = {
    ...(personalSummary && personalSummary.id && { id: personalSummary.id }),
    aboutYourself: personalSummary?.aboutYourself || '',
    industryTags: industries?.values || [],
    financialTags: skills?.values || [],
    softwareTags: software?.values || [],
    topIndustries: personalSummary?.topIndustries || [],
    topFinancialSkills: personalSummary?.topFinancialSkills || [],
    topSoftwareSkills: personalSummary?.topSoftwareSkills || [],
    whyFreelanceWork: personalSummary?.whyFreelanceWork || '',
  }

  return (
    <Grid container>
      <Grid item>
        <OnboardingSectionTitle
          title="All About You"
          description="Clients using the Paro platform want to know all about YOU! Now is the time to impress clients with a pitch highlighting what makes you an elite finance/accounting freelancer!"
        />
      </Grid>
      <Grid item>
        <PitchForm initialValues={initialValues} />
      </Grid>
    </Grid>
  )
}

export default Pitch
